module.exports = __webpack_public_path__ + "img/CM.3588e07d.png";